import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

const fixed = css`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
`;

const CloseModal = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4141 12L17.7071 7.70701C18.0981 7.31601 18.0981 6.68401 17.7071 6.29301C17.3161 5.90201 16.6841 5.90201 16.2931 6.29301L12.0001 10.586L7.70713 6.29301C7.31613 5.90201 6.68413 5.90201 6.29313 6.29301C5.90213 6.68401 5.90213 7.31601 6.29313 7.70701L10.5861 12L6.29313 16.293C5.90213 16.684 5.90213 17.316 6.29313 17.707C6.48813 17.902 6.74413 18 7.00013 18C7.25613 18 7.51213 17.902 7.70713 17.707L12.0001 13.414L16.2931 17.707C16.4881 17.902 16.7441 18 17.0001 18C17.2561 18 17.5121 17.902 17.7071 17.707C18.0981 17.316 18.0981 16.684 17.7071 16.293L13.4141 12Z"
            fill="#C4C9CB"
        />
    </svg>
);

const Overlay = styled.div`
    background-color: rgba(0, 0, 0, 0.5);
    ${fixed};
    ${({ $show, $priority }) =>
        $show
            ? css`
                    opacity: 1;
                    z-index: ${$priority ? 1000 : 100};
              `
            : css`
                    opacity: 0;
                    z-index: 1;
                    pointer-events: none;
              `};
    transition: opacity 0.3s;
`;

const QrModalContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1001;
    opacity: ${({ $show }) => ($show ? 1 : 0)};
    pointer-events: ${({ $show }) => ($show ? 'auto' : 'none')};
    transition: opacity 0.3s ease-in-out;

    ${({ $show }) =>
        $show &&
        css`
            animation: fadeIn 0.3s ease-in-out;
        `}

    ${({ $show }) =>
        !$show &&
        css`
            animation: fadeOut 0.3s ease-in-out;
        `}

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes fadeOut {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
        }
    }
`;

const QrModalContent = styled.div`
    background-color: #ebfaf8;
    border-radius: 8px;
    border: 1px solid #9aede2;
    padding: 40px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 420px;
    animation: ${({ $show }) =>
        $show ? 'slideIn 0.3s ease-out' : 'slideOut 0.3s ease-out'};

    @keyframes slideIn {
        from {
            transform: translateY(-20px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    @keyframes slideOut {
        from {
            transform: translateY(0);
            opacity: 1;
        }
        to {
            transform: translateY(-20px);
            opacity: 0;
        }
    }
`;

const QrModalClose = styled.button`
    position: absolute;
    top: 16px;
    right: 16px;
    padding: 0;
    background: none;
    border: none;
    font-size: 14px;
    font-weight: bold;
    color: #c4c9cb;
    cursor: pointer;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
`;

const QrModalTitle = styled.h2`
    margin-top: 0;
    margin-bottom: 24px;
    font-size: 16px;
    line-height: 21px;
    font-weight: 600;
    color: #323232;
    text-align: center;
`;

const QrModalSubtitle = styled.p`
    margin-top: 0;
    margin-bottom: 18px;
    font-size: 16px;
    line-height: 21px;
    color: #000000;
    text-align: center;
`;

const QrModalImage = styled.img`
    width: 240px;
    height: 240px;
    border-radius: 6px;
    border: 1px solid #9aede2;
`;

export const QrModal = ({ show, onClose, qrImage }) => {
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        if (show) {
            setShouldRender(true);
        } else {
            const timer = setTimeout(() => {
                setShouldRender(false);
            }, 300);

            return () => clearTimeout(timer);
        }
    }, [show]);

    const handleContentClick = (e) => {
        e.stopPropagation();
    };

    if (!shouldRender) return null;

    return (
        <>
            <Overlay $show={show} onClick={onClose} $priority={true} />
            <QrModalContainer $show={show} onClick={onClose}>
                <QrModalContent $show={show} onClick={handleContentClick}>
                    <QrModalClose>
                        <CloseModal onClick={onClose} />
                    </QrModalClose>
                    <QrModalTitle>Access all features in our mobile app</QrModalTitle>
                    <QrModalSubtitle>Scan the QR code to switch:</QrModalSubtitle>
                    <QrModalImage src={qrImage} alt="QR Code" />
                </QrModalContent>
            </QrModalContainer>
        </>
    );
};
